import { render, staticRenderFns } from "./Pill.vue?vue&type=template&id=0d6937a8&scoped=true&"
var script = {}
import style0 from "./Pill.vue?vue&type=style&index=0&id=0d6937a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6937a8",
  null
  
)

export default component.exports